import { createClient } from '@supabase/supabase-js';

/**
 * Supabase client singleton.
 *
 * Reads VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY from Vite's env.
 * Set these in apps/web/.env.local (never commit the file).
 *
 * Fallback values point to a local Supabase dev stack (supabase start)
 * so the client can be imported safely in tests without throwing.
 */
const supabaseUrl =
  (import.meta.env['VITE_SUPABASE_URL'] as string | undefined) ??
  'http://localhost:54321';

const supabaseAnonKey =
  (import.meta.env['VITE_SUPABASE_ANON_KEY'] as string | undefined) ??
  'placeholder-anon-key';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    flowType: 'pkce',
    detectSessionInUrl: true,
    autoRefreshToken: true,
    persistSession: true,
  },
});
